<app-pias-layout>
  <div pias-layout-content>
    <br />
    @if(this.setSprinner()) {
    <div class="pias-spinner">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    }
    <div class="page-header-section">
      <div class="page-header-left">
        <div class="title-container">
          <h4 class="page-title">Annual Declaration</h4>

          <div class="status-chip-box">
            <span class="status-label">Current Status:</span>

            @if (workflowStatus) {
            <span class="status-badge-header" [ngClass]="{
            'status-approved': workflowStatus === 'APPROVED',
            'status-inreview': workflowStatus === 'IN_REVIEW',
            'status-submitted': workflowStatus === 'SUBMITTED',
            'status-returned': workflowStatus === 'RETURNED',
            'status-inprogress': workflowStatus === 'IN PROGRESS',
            'status-notstated': workflowStatus === 'NOT STARTED',
          }">
             {{ workflowStatus.replace('_', ' ') }}
            </span>
            } @else {
            <span class="status-badge status-loading">Loading...</span>
            }
          </div>
        </div>
      </div>
    </div>
    <form [formGroup]="formGroup">
      <div class="all-section-verified">
        <mat-checkbox formControlName="allsectionverified" color="primary" (change)="allSectionVerifed($event.checked)">
          Mark as All section Verified
        </mat-checkbox>
      </div>
      <mat-accordion>
        <!-- Personal Particulars -->
        <mat-expansion-panel formGroupName="personalInfo" [expanded]="this.currentStep === 0">
          <mat-expansion-panel-header (click)="changeIndex(0)">
            <div class="header-content">
              <mat-panel-title class="page-header">
                <mat-icon class="header-icon">person</mat-icon>
                Personal Particulars
              </mat-panel-title>
            </div>
          </mat-expansion-panel-header>
          <!-- <h5 class="field-title">Information on New Representative</h5> -->
          <!-- <div class="bdm-container container-fluid"> -->
          <div class="row g-3">
            <!-- Full Name -->
            <div class="col-md-6">
              <mat-label class="field-label">Full Name as in NRIC</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="fullName" placeholder="Enter Name as in NRIC" />
              </mat-form-field>
            </div>

            <!-- MAS Representative No -->
            <div class="col-md-6">
              <mat-label class="field-label">MAS Representative No</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="representative_no" placeholder="Enter MAS Representative No " />
              </mat-form-field>
            </div>

            <!-- Branch -->
            <div class="col-md-6">
              <mat-label class="field-label">Branch</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="branch" placeholder="Enter Branch" />
              </mat-form-field>
            </div>

            <!-- Pias Rep Code -->
            <div class="col-md-6">
              <mat-label class="field-label">PIAS Rep Code</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="repcode" placeholder="Enter Pias Rep Code" />
              </mat-form-field>
            </div>

            <!-- NRIC -->
            <div class="col-md-6">
              <mat-label class="field-label">NRIC No.</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="nric" placeholder="Enter NRIC No." />
              </mat-form-field>
            </div>
          </div>

          <!-- Nationality Section -->
          <div class="section-card mt-4">
            <h3 class="field-label">
              <!-- <mat-icon>flag</mat-icon> -->
              Nationality
            </h3>

            <mat-radio-group formControlName="nationality" class="d-flex flex-wrap gap-3 mb-3">
              <mat-radio-button value="Singapore Citizen">Singapore Citizen</mat-radio-button>
              <mat-radio-button value="Singapore Permanent Resident">Singapore Permanent Resident</mat-radio-button>
              <mat-radio-button value="others">Others</mat-radio-button>
            </mat-radio-group>

            <p class="note">For Singapore Permanent Resident & Others, please state:</p>
            <div class="row g-3">
              <div class="col-md-6">
                <mat-label class="field-label">Nationality</mat-label>
                <mat-form-field class="w-100">
                  <mat-select formControlName="otherNationality" placeholder="Select Nationality" required>
                    @for(nationality of this.nationalities; track nationality) {
                    <mat-option value="{{nationality.value}}">{{nationality.name}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <!-- Country Of Birth -->
              <div class="col-md-6">
                <mat-label class="field-label">Country Of Birth</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="countryofbirth" placeholder="Enter Country Of Birth " />
                </mat-form-field>
              </div>
              <!-- FIN No -->
              <div class="col-md-6">
                <mat-label class="field-label">FIN or Passport No</mat-label>
                <mat-form-field class="w-100 custom-form-field">
                  <input matInput formControlName="fin_No" placeholder="Enter FIN or Passport No" />
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row g-3">
            <!-- Email Address -->
            <div class="col-md-6">
              <mat-label class="field-label">Personal Email Address</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="email" placeholder="Enter Personal Email Address:" />
              </mat-form-field>
            </div>

            <!-- Race Section -->
            <div class="section-card mt-4">
              <h3 class="field-label">
                <!-- <mat-icon>supervisor_account</mat-icon> -->
                Race
              </h3>

              <div class="row">
                <div class="col-md-12">
                  <mat-radio-group formControlName="race" class="d-flex flex-wrap gap-3" required>
                    <mat-radio-button value="chinese">Chinese</mat-radio-button>
                    <mat-radio-button value="malay">Malay</mat-radio-button>
                    <mat-radio-button value="indian">Indian</mat-radio-button>
                    <mat-radio-button value="others">Others</mat-radio-button>
                  </mat-radio-group>
                </div>

                @if (formGroup.get('personalInfo.race')?.value === 'others') {
                <div class="col-md-6 mt-3">
                  <mat-label class="field-label">Specify Race</mat-label>
                  <mat-form-field class="w-100">
                    <input matInput formControlName="raceSpecify" placeholder="Please specify" />
                  </mat-form-field>
                </div>
                }
              </div>
            </div>

            <!-- Marital Status -->
            <div class="section-card mt-4">
              <h3 class="field-label">
                <!-- <mat-icon>favorite</mat-icon> -->
                Marital Status
              </h3>

              <mat-radio-group formControlName="maritalStatus" class="d-flex flex-wrap gap-3">
                <mat-radio-button value="single">Single</mat-radio-button>
                <mat-radio-button value="Married">Married</mat-radio-button>
                <mat-radio-button value="widowed">Widowed</mat-radio-button>
                <mat-radio-button value="divorced">Divorced</mat-radio-button>
              </mat-radio-group>
            </div>

            <!-- Residential Address -->
            <div class="col-md-6">
              <mat-label class="field-label">Residential Address</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="address" placeholder="Enter Residential Address" />
              </mat-form-field>
            </div>

            <!-- Contact Number -->
            <p class="field-label">Contact Number</p>
            <div class="col-md-6">
              <mat-label class="field-label">Home</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="homenumber" placeholder="Enter Home Number" />
              </mat-form-field>
            </div>

            <div class="col-md-6">
              <mat-label class="field-label">Mobile</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="mobilenumber" placeholder="Enter Mobile Number" />
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Spouse Details -->
        <mat-expansion-panel formGroupName="spouseInfo" [expanded]="this.currentStep === 1">
          <mat-expansion-panel-header (click)="changeIndex(1)">
            <div class="header-content">
              <mat-panel-title class="page-header">
                <mat-icon class="header-icon">wc</mat-icon>
                Spouse Details
              </mat-panel-title>
            </div>
          </mat-expansion-panel-header>
          <div class="row g-3">
            <!-- Spouse Name as in NRIC -->
            <div class="col-md-6">
              <mat-label class="field-label">Spouse Name as in NRIC</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="spousename" placeholder="Enter Spouse Name as in NRIC" />
              </mat-form-field>
            </div>

            <!-- Spouse NRIC No. -->
            <div class="col-md-6">
              <mat-label class="field-label">Spouse NRIC No</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="spouse_no" placeholder="Enter Spouse NRIC No" />
              </mat-form-field>
            </div>

            <!-- spouse_dob -->
            <div class="col-md-6">
              <mat-label class="field-label">Spouse Date of Birth</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input formControlName="spouse_dob" matInput [matDatepicker]="picker" />
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>

            <!-- Spouse Occupation & Name of Employer -->
            <div class="col-md-6">
              <mat-label class="field-label">Spouse Occupation & Name of Employer</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="spouse_occupation"
                  placeholder="Enter Spouse Occupation & Name of Employer" />
              </mat-form-field>
            </div>

            <!--  Name of Employer -->
            <div class="col-md-6">
              <mat-label class="field-label">Name of Employer</mat-label>
              <mat-form-field class="w-100 custom-form-field">
                <input matInput formControlName="spouse_employer" placeholder="Enter Name of Employer" />
              </mat-form-field>
            </div>
          </div>
          <!-- @if (this.mode != 'view') { -->
          <!-- Form Actions -->
          <!-- <div class="form-actions mt-4 text-end">
            <button class="save-btn" (click)="saveAndContinue('spouseInfo')">
              <span>Save & Continue</span>
              <mat-icon>arrow_forward</mat-icon>
            </button>
          </div> -->
          <!-- } -->
        </mat-expansion-panel>

        <!-- Business Interests and Shareholdings/ Ownership -->
        <mat-expansion-panel [expanded]="this.currentStep === 2">
          <mat-expansion-panel-header (click)="changeIndex(2)">
            <div class="header-content">
              <mat-panel-title class="page-header">
                <mat-icon class="header-icon">add_chart</mat-icon>
                Business Interests and Shareholdings/ Ownership
              </mat-panel-title>

              <span class="section-verified">
                <mat-checkbox formControlName="questionnaire1verified" color="primary"
                  (change)="sectionVerified($event.checked,'questionnaire1')">
                  Mark as section Verified
                </mat-checkbox>
              </span>

              @if (this.questionnaire1FormValid() === 'Verified') {
              <span class="status-badge verified m-4">
                <mat-icon>verified_user</mat-icon>
                Verified
              </span>
              } @else {
              <span class="status-badge inreview m-4">
                <mat-icon>schedule</mat-icon>
                In Review
              </span>
              }
            </div>
          </mat-expansion-panel-header>
          <div class="check-list" formGroupName="questionnaire1">
            <ol class="custom-list">
              @for (q of questionnaire1Questions; track q.id) {
              <li [formGroupName]="q.id"
                [ngClass]="{ 'changed-row-highlight': getQuestionGroup('questionnaire1', q.id)?.get('changed')?.value}">
                <div class="row">
                  <!-- QUESTION -->
                  <div class="col-sm-10">
                    <div class="d-flex align-items-center gap-2">
                      <span class="question-text">{{ q.question }}</span>

                      @if (getQuestionGroup('questionnaire1', q.id)?.get('changed')?.value) {
                      <span class="delta-badge">
                        <mat-icon class="delta-icon">update</mat-icon> Changed
                      </span>
                      }
                    </div>
                    <p *ngIf="q.note" class="note">{{ q.note }}</p>
                  </div>

                  <!-- YES / NO -->
                  <div class="col-sm-2">
                    <mat-radio-group formControlName="answer">
                      <mat-radio-button [value]="true"> Yes </mat-radio-button>

                      <mat-radio-button [value]="false"> No </mat-radio-button>
                    </mat-radio-group>
                  </div>

                  <!-- CONDITIONAL -->
                  @if (getQuestionGroup('questionnaire1', q.id)?.get('answer')?.value) {
                  <div class="col-12 mt-3">
                    <mat-label>
                      {{ q.inputLabel }}
                    </mat-label>

                    <div class="row">
                      <!-- ENTITY -->
                      <div class="col-md-12">
                        <mat-form-field class="w-50 custom-form-field">
                          <input matInput formControlName="entityCount" placeholder="Enter text here" />
                        </mat-form-field>
                      </div>

                      <!-- ATTACHMENT -->
                      @if (q.hasAttachment) {
                      @if (getQuestionGroup('questionnaire1', q.id)?.get('noAttachment')?.value != true) {
                      <div class="col-md-6">
                        <div class="upload-container">
                          <div class="upload-box">
                            <!-- EMPTY -->
                            @if (
                            !getQuestionGroup('questionnaire1', q.id)?.get(
                            'attachment.fileName'
                            )?.value
                            ) {
                            <label class="upload-placeholder">
                              <input type="file" #fileInput />

                              <!-- <mat-icon> upload_file </mat-icon> -->

                              <span> Choose file </span>
                            </label>
                            }

                            <!-- FILE SELECTED -->
                            @if (
                            getQuestionGroup('questionnaire1', q.id)?.get(
                            'attachment.fileName'
                            )?.value
                            ) {
                            <div class="file-preview">
                              <div class="file-info">
                                <mat-icon class="file-icon"> description </mat-icon>

                                <span class="file-name">
                                  {{
                                  getQuestionGroup('questionnaire1', q.id)?.get(
                                  'attachment.fileName'
                                  )?.value
                                  }}
                                </span>
                              </div>
                              @if (loggedInRole === 'DSU Manager' || loggedInRole === 'DSU') {
                              <button mat-icon-button type="button" color="primary" matTooltip="Preview Document"
                                (click)="previewAttachment('questionnaire1', q.id)">
                                <mat-icon>visibility</mat-icon>
                              </button>
                              }

                            </div>
                            }
                          </div>
                        </div>
                      </div>
                      }

                      <!-- NO ATTACHMENT -->
                      <div class="col-3">
                        <mat-checkbox formControlName="noAttachment">
                          No Attachment
                        </mat-checkbox>
                      </div>
                      }

                      <!-- REASON -->
                      @if (
                      getQuestionGroup('questionnaire1', q.id)?.get('noAttachment')?.value
                      ) {
                      <div class="w-100 mt-2">
                        <mat-form-field class="w-100">
                          <textarea matInput rows="2" formControlName="noAttachmentReason"
                            placeholder="Enter reason"></textarea>
                        </mat-form-field>
                      </div>
                      }
                    </div>
                  </div>
                  }

                  @if (loggedInRole === 'DSU Manager'|| loggedInRole === 'DSU') {
                  <div class="col-12 mt-3">
                    <div class="DSU Manager-review-card p-3">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <span class="fw-bold text-primary">DSU Verification</span>
                        <mat-checkbox formControlName="isVerified" color="primary">
                          Mark as Verified
                        </mat-checkbox>
                        @if (
                        getQuestionGroup('questionnaire1', q.id)
                        ?.get('isVerified')
                        ?.hasError('required') &&
                        getQuestionGroup('questionnaire1', q.id)?.get('isVerified')
                        ?.touched
                        ) {
                        <mat-error> This field is required. </mat-error>
                        }
                      </div>

                      <mat-label class="form-label">Review Notes</mat-label>
                      <mat-form-field class="w-100">
                        <textarea matInput rows="2" formControlName="managerComment" maxlength="1000"></textarea>
                      </mat-form-field>
                      <mat-label class="form-label">Returned Notes</mat-label>
                      <mat-form-field class="w-100">
                        <textarea matInput rows="2" formControlName="advisorComment" maxlength="1000"></textarea>
                      </mat-form-field>
                    </div>
                  </div>
                  }
                </div>
              </li>
              }
            </ol>
          </div>

          <!-- Form Actions -->
          @if (this.mode != 'view') {
          <div class="form-actions mt-4 text-end">
            <button class="save-btn" (click)="saveAndContinue('questionnaire1')">
              <span>Save & Continue</span>
              <mat-icon>arrow_forward</mat-icon>
            </button>
          </div>
          }
        </mat-expansion-panel>

        <!-- General Information -->
        <mat-expansion-panel [expanded]="this.currentStep === 3">
          <mat-expansion-panel-header (click)="changeIndex(3)">
            <div class="header-content">
              <mat-panel-title class="page-header">
                <mat-icon class="header-icon">info</mat-icon>
                General Information
              </mat-panel-title>
              <span class="section-verified">
                <mat-checkbox formControlName="questionnaire2verified" color="primary"
                  (change)="sectionVerified($event.checked,'questionnaire2')">
                  Mark as section Verified
                </mat-checkbox>
              </span>
              @if ( this.questionnaire2FormValid() === 'Verified') {
              <span class="status-badge verified m-4">
                <mat-icon>verified_user</mat-icon>
                Verified
              </span>

              } @else {
              <span class="status-badge inreview m-4">
                <mat-icon>schedule</mat-icon>
                In Review
              </span>
              }
            </div>
          </mat-expansion-panel-header>
          <div class="check-list" formGroupName="questionnaire2">
            <ol class="custom-list">
              @for (q of questionnaire2Questions; track q.id) {
              <li [formGroupName]="q.id"
                [ngClass]="{ 'changed-row-highlight': getQuestionGroup('questionnaire2', q.id)?.get('changed')?.value}">
                <div class="row">
                  <!-- QUESTION -->
                  <div class="col-sm-10">
                    <div class="d-flex align-items-center gap-2">
                      <span class="question-text">{{ q.question }}</span>

                      @if (getQuestionGroup('questionnaire2', q.id)?.get('changed')?.value) {
                      <span class="delta-badge">
                        <mat-icon class="delta-icon">update</mat-icon> Changed
                      </span>
                      }
                    </div>
                  </div>

                  <!-- YES / NO -->
                  <div class="col-sm-2">
                    <mat-radio-group formControlName="answer">
                      <mat-radio-button [value]="true"> Yes </mat-radio-button>

                      <mat-radio-button [value]="false"> No </mat-radio-button>
                    </mat-radio-group>
                  </div>

                  <!-- CONDITIONAL -->
                  @if (getQuestionGroup('questionnaire2', q.id)?.get('answer')?.value) {
                  <div class="col-12 mt-3">
                    @if (q.inputLabel) {
                    <mat-label>
                      {{ q.inputLabel }}
                    </mat-label>
                    }

                    <div class="row">
                      <!-- ENTITY -->
                      @if (q.inputLabel) {
                      <div class="col-md-12">
                        <mat-form-field class="w-50 custom-form-field">
                          <input matInput formControlName="entityCount" placeholder="Enter text here" />
                        </mat-form-field>
                      </div>
                      }

                      <!-- ATTACHMENT -->
                      @if (q.hasAttachment) {
                      @if (getQuestionGroup('questionnaire2', q.id)?.get('noAttachment')?.value != true) {
                      <div class="col-md-6">
                        <div class="upload-container">
                          <div class="upload-box">
                            <!-- EMPTY -->
                            @if (
                            !getQuestionGroup('questionnaire2', q.id)?.get(
                            'attachment.fileName'
                            )?.value
                            ) {
                            <label class="upload-placeholder">
                              <input type="file" #fileInput />

                              <span> Choose file </span>
                            </label>
                            }

                            <!-- FILE SELECTED -->
                            @if (
                            getQuestionGroup('questionnaire2', q.id)?.get(
                            'attachment.fileName'
                            )?.value
                            ) {
                            <div class="file-preview">
                              <div class="file-info">
                                <mat-icon class="file-icon"> description </mat-icon>

                                <span class="file-name">
                                  {{
                                  getQuestionGroup('questionnaire2', q.id)?.get(
                                  'attachment.fileName'
                                  )?.value
                                  }}
                                </span>
                              </div>
                              @if (loggedInRole === 'DSU Manager' || loggedInRole === 'DSU') {
                              <button mat-icon-button type="button" color="primary" matTooltip="Preview Document"
                                (click)="previewAttachment('questionnaire2', q.id)">
                                <mat-icon>visibility</mat-icon>
                              </button>
                              }

                            </div>
                            }
                          </div>
                        </div>
                      </div>
                      }

                      <!-- NO ATTACHMENT -->
                      <div class="col-3">
                        <mat-checkbox formControlName="noAttachment">
                          No Attachment
                        </mat-checkbox>
                      </div>
                      }

                      <!-- REASON -->
                      @if (
                      getQuestionGroup('questionnaire2', q.id)?.get('noAttachment')?.value
                      ) {
                      <div class="w-100 mt-2">
                        <mat-form-field class="w-100">
                          <textarea matInput rows="2" formControlName="noAttachmentReason"
                            placeholder="Enter reason"></textarea>
                        </mat-form-field>
                      </div>
                      }
                    </div>
                  </div>
                  }

                  @if (loggedInRole === 'DSU Manager' || loggedInRole === 'DSU') {
                  <div class="col-12 mt-3">
                    <div class="DSU Manager-review-card p-3">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <span class="fw-bold text-primary">DSU Verification</span>
                        <mat-checkbox formControlName="isVerified" color="primary">
                          Mark as Verified
                        </mat-checkbox>
                        @if (
                        getQuestionGroup('questionnaire2', q.id)?.get('isVerified')?.hasError('required') &&
                        getQuestionGroup('questionnaire2', q.id)?.get('isVerified')?.touched
                        ) {
                        <mat-error> This field is required. </mat-error>
                        }
                      </div>

                      <mat-label class="form-label">Review Notes</mat-label>
                      <mat-form-field class="w-100">
                        <textarea matInput rows="2" formControlName="managerComment" maxlength="1000"></textarea>
                      </mat-form-field>
                      <mat-label class="form-label">Returned Notes</mat-label>
                      <mat-form-field class="w-100">
                        <textarea matInput rows="2" formControlName="advisorComment" maxlength="1000"></textarea>
                      </mat-form-field>
                    </div>
                  </div>
                  }
                </div>
              </li>
              }
            </ol>
          </div>

          <!-- Form Actions -->
          @if (this.mode != 'view') {
          <div class="form-actions mt-4 text-end">
            <button class="save-btn" (click)="saveAndContinue('questionnaire2')">
              <span>Save & Continue</span>
              <mat-icon>arrow_forward</mat-icon>
            </button>
          </div>
          }
        </mat-expansion-panel>

        <!-- Fit and Proper Criteria -->
        <mat-expansion-panel [expanded]="this.currentStep === 4">
          <mat-expansion-panel-header (click)="changeIndex(4)">
            <div class="header-content">
              <mat-panel-title class="page-header">
                <mat-icon class="header-icon">verified_user</mat-icon>
                Fit and Proper Criteria
              </mat-panel-title>
              <span class="section-verified">
                <mat-checkbox formControlName="questionnaire3verified" color="primary"
                  (change)="sectionVerified($event.checked,'questionnaire3')">
                  Mark as section Verified
                </mat-checkbox>
              </span>
              @if ( this.questionnaire3FormValid() === 'Verified') {
              <span class="status-badge verified m-4">
                <mat-icon>verified_user</mat-icon>
                Verified
              </span>
              } @else {
              <span class="status-badge inreview m-4">
                <mat-icon>schedule</mat-icon>
                In Review
              </span>
              }
            </div>
          </mat-expansion-panel-header>
          <div class="check-list" formGroupName="questionnaire3">
            <ol class="custom-list">
              @for (q of questionnaire3Questions; track q.id) {
              <li [formGroupName]="q.id"
                [ngClass]="{ 'changed-row-highlight': getQuestionGroup('questionnaire3', q.id)?.get('changed')?.value}">
                <div class="row">
                  <div class="col-sm-10">
                    <div class="d-flex align-items-center gap-2">
                      <span class="question-text">{{ q.question }}</span>

                      @if (getQuestionGroup('questionnaire3', q.id)?.get('changed')?.value) {
                      <span class="delta-badge">
                        <mat-icon class="delta-icon">update</mat-icon> Changed
                      </span>
                      }
                    </div>

                    @if (q.description) {
                    <div class="text-muted mt-2 note" style="font-size: 0.85em; white-space: pre-wrap">
                      {{ q.description }}
                    </div>
                    }
                  </div>

                  <div class="col-sm-2">
                    <mat-radio-group formControlName="answer">
                      <mat-radio-button [value]="true"> Yes </mat-radio-button>
                      <mat-radio-button [value]="false"> No </mat-radio-button>
                    </mat-radio-group>
                  </div>

                  @if (getQuestionGroup('questionnaire3', q.id)?.get('answer')?.value) {
                  <div class="col-12 mt-3 user-inputs">
                    @if (q.inputLabel) {
                    <mat-label>{{ q.inputLabel }}</mat-label>
                    }

                    <div class="row">
                      @if (q.inputLabel) {
                      <div class="col-md-12">
                        <mat-form-field class="w-50 custom-form-field">
                          <input matInput formControlName="entityCount" placeholder="Enter text here" />
                        </mat-form-field>
                      </div>
                      }

                      @if (q.hasAttachment) {
                      @if (getQuestionGroup('questionnaire3', q.id)?.get('noAttachment')?.value != true) {
                      <div class="col-md-6">
                        <div class="upload-container">
                          <div class="upload-box">
                            @if (
                            !getQuestionGroup('questionnaire3', q.id)?.get(
                            'attachment.fileName'
                            )?.value
                            ) {
                            <label class="upload-placeholder">
                              <input type="file" #fileInput />
                              <span> Choose file </span>
                            </label>
                            }

                            @if (
                            getQuestionGroup('questionnaire3', q.id)?.get(
                            'attachment.fileName'
                            )?.value
                            ) {
                            <div class="file-preview">
                              <div class="file-info">
                                <mat-icon class="file-icon"> description </mat-icon>
                                <span class="file-name">
                                  {{
                                  getQuestionGroup('questionnaire3', q.id)?.get(
                                  'attachment.fileName'
                                  )?.value
                                  }}
                                </span>
                              </div>
                              @if (loggedInRole === 'DSU Manager' || loggedInRole === 'DSU') {
                              <button mat-icon-button type="button" color="primary" matTooltip="Preview Document"
                                (click)="previewAttachment('questionnaire3', q.id)">
                                <mat-icon>visibility</mat-icon>
                              </button>
                              }

                            </div>
                            }
                          </div>
                        </div>
                      </div>
                      }

                      <div class="col-3">
                        <mat-checkbox formControlName="noAttachment">
                          No Attachment
                        </mat-checkbox>
                      </div>
                      }

                      @if (
                      getQuestionGroup('questionnaire3', q.id)?.get('noAttachment')?.value
                      ) {
                      <div class="w-100 mt-2">
                        <mat-form-field class="w-100">
                          <textarea matInput rows="2" formControlName="noAttachmentReason"
                            placeholder="Enter reason"></textarea>
                        </mat-form-field>
                      </div>
                      }
                    </div>
                  </div>
                  }

                  @if (loggedInRole === 'DSU Manager' || loggedInRole === 'DSU') {
                  <div class="col-12 mt-3">
                    <div class="DSU Manager-review-card p-3">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <span class="fw-bold text-primary">DSU Verification</span>
                        <mat-checkbox formControlName="isVerified" color="primary">
                          Mark as Verified
                        </mat-checkbox>
                        @if (
                        getQuestionGroup('questionnaire3', q.id)?.get('isVerified')?.hasError('required') &&
                        getQuestionGroup('questionnaire3', q.id)?.get('isVerified')?.touched
                        ) {
                        <mat-error> This field is required. </mat-error>
                        }
                      </div>

                      <mat-label class="form-label">Review Notes</mat-label>
                      <mat-form-field class="w-100">
                        <textarea matInput rows="2" formControlName="managerComment" maxlength="1000"></textarea>
                      </mat-form-field>
                      <mat-label class="form-label">Returned Notes</mat-label>
                      <mat-form-field class="w-100">
                        <textarea matInput rows="2" formControlName="advisorComment" maxlength="1000"></textarea>
                      </mat-form-field>
                    </div>
                  </div>
                  }
                </div>
              </li>
              }
            </ol>
          </div>
          @if (this.mode != 'view') {
          <div class="form-actions mt-4 text-end">
            <button class="save-btn" (click)="saveAndContinue('questionnaire3')">
              <span>Save & Continue</span>
              <mat-icon>arrow_forward</mat-icon>
            </button>
          </div>
          }
        </mat-expansion-panel>

        <!-- Tier 2 and Tier 3 Supervisor attestation -->
        @if (selectedUserrole !== 'Advisor') {
        <mat-expansion-panel [expanded]="this.currentStep === 5">
          <mat-expansion-panel-header (click)="changeIndex(5)">
            <div class="header-content">
              <mat-panel-title class="page-header">
                <mat-icon class="header-icon"> supervisor_account </mat-icon>

                Tier 2 and Tier 3 Supervisor attestation
              </mat-panel-title>
              <span class="section-verified">
                <mat-checkbox class="text-end" formControlName="questionnaire4verified" color="primary"
                  (change)="sectionVerified($event.checked,'questionnaire4')">
                  Mark as section Verified
                </mat-checkbox>
              </span>
              @if ( this.questionnaire4FormValid() === 'Verified') {
              <span class="status-badge verified m-4">
                <mat-icon>verified_user</mat-icon>
                Verified
              </span>
              } @else {
              <span class="status-badge inreview m-4">
                <mat-icon>schedule</mat-icon>
                In Review
              </span>
              }
            </div>
          </mat-expansion-panel-header>
          <div class="check-list" formGroupName="questionnaire4">
            <ol class="custom-list">
              @for (q of questionnaire4Questions; track q.id) {
              <li [formGroupName]="q.id"
                [ngClass]="{ 'changed-row-highlight': getQuestionGroup('questionnaire4', q.id)?.get('changed')?.value}">
                <div class="row">
                  <!-- QUESTION -->
                  <div class="col-sm-10">
                    <span>
                      {{ q.question }}
                    </span>

                    @if (getQuestionGroup('questionnaire4', q.id)?.get('changed')?.value) {
                    <span class="delta-badge">
                      <mat-icon class="delta-icon">update</mat-icon> Changed
                    </span>
                    }
                  </div>

                  <!-- YES / NO -->
                  <div class="col-sm-2">
                    <mat-radio-group formControlName="answer">
                      <mat-radio-button [value]="true"> Yes </mat-radio-button>

                      <mat-radio-button [value]="false"> No </mat-radio-button>
                    </mat-radio-group>
                  </div>

                  <!-- CONDITIONAL -->
                  @if (getQuestionGroup('questionnaire4', q.id)?.get('answer')?.value) {
                  <div class="col-12 mt-3">
                    <mat-label>
                      <!-- {{ q.inputLabel }} -->
                    </mat-label>

                    <div class="row">
                      <!-- ENTITY -->
                      <div class="col-md-12">
                        <mat-form-field class="w-50 custom-form-field">
                          <input matInput formControlName="entityCount" placeholder="Enter text here" />
                        </mat-form-field>
                      </div>

                      <!-- ATTACHMENT -->
                      @if (q.hasAttachment) {
                      @if (getQuestionGroup('questionnaire4', q.id)?.get('noAttachment')?.value != true) {
                      <div class="col-md-6">
                        <div class="upload-container">
                          <div class="upload-box">
                            <!-- EMPTY -->
                            @if (
                            !getQuestionGroup('questionnaire4', q.id)?.get(
                            'attachment.fileName'
                            )?.value
                            ) {
                            <label class="upload-placeholder">
                              <input type="file" #fileInput />

                              <span> Choose file </span>
                            </label>
                            }

                            <!-- FILE SELECTED -->
                            @if (
                            getQuestionGroup('questionnaire4', q.id)?.get(
                            'attachment.fileName'
                            )?.value
                            ) {
                            <div class="file-preview">
                              <div class="file-info">
                                <mat-icon class="file-icon"> description </mat-icon>

                                <span class="file-name">
                                  {{
                                  getQuestionGroup('questionnaire4', q.id)?.get(
                                  'attachment.fileName'
                                  )?.value
                                  }}
                                </span>
                              </div>
                              @if (loggedInRole === 'DSU Manager' || loggedInRole === 'DSU') {
                              <button mat-icon-button type="button" color="primary" matTooltip="Preview Document"
                                (click)="previewAttachment('questionnaire4', q.id)">
                                <mat-icon>visibility</mat-icon>
                              </button>
                              }
                            </div>
                            }
                          </div>
                        </div>
                      </div>
                      }

                      <!-- NO ATTACHMENT -->
                      <div class="col-3">
                        <mat-checkbox formControlName="noAttachment">
                          No Attachment
                        </mat-checkbox>
                      </div>
                      }

                      <!-- REASON -->
                      @if (
                      getQuestionGroup('questionnaire4', q.id)?.get('noAttachment')?.value
                      ) {
                      <div class="w-100 mt-2">
                        <mat-form-field class="w-100">
                          <textarea matInput rows="2" formControlName="noAttachmentReason" placeholder="Enter reason">
                                </textarea>
                        </mat-form-field>
                      </div>
                      }
                    </div>
                  </div>
                  }
                  @if (loggedInRole === 'DSU Manager' || loggedInRole === 'DSU') {
                  <div class="col-12 mt-3">
                    <div class="DSU Manager-review-card p-3">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <span class="fw-bold text-primary">DSU Verification</span>
                        <mat-checkbox formControlName="isVerified" color="primary">
                          Mark as Verified
                        </mat-checkbox>
                        @if (
                        getQuestionGroup('questionnaire4', q.id)?.get('isVerified')?.hasError('required') &&
                        getQuestionGroup('questionnaire4', q.id)?.get('isVerified')?.touched
                        ) {
                        <mat-error> This field is required. </mat-error>
                        }
                      </div>

                      <mat-label class="form-label">Review Notes</mat-label>
                      <mat-form-field class="w-100">
                        <textarea matInput rows="2" formControlName="managerComment" maxlength="1000"></textarea>
                      </mat-form-field>
                      <mat-label class="form-label">Returned Notes</mat-label>
                      <mat-form-field class="w-100">
                        <textarea matInput rows="2" formControlName="advisorComment" maxlength="1000"></textarea>
                      </mat-form-field>
                    </div>
                  </div>
                  }
                </div>
              </li>
              }
            </ol>
          </div>

          <div class="form-actions mt-4 text-end">
            @if (this.mode != 'view') {
            <button class="save-btn" (click)="saveAndContinue('questionnaire4')">
              <span>Save & Continue</span>
              <mat-icon>arrow_forward</mat-icon>
            </button>
            }
          </div>
        </mat-expansion-panel>
        }

        <!-- Miscellaneous -->
        <mat-expansion-panel formGroupName="miscellaneous" [expanded]="this.currentStep === 6">
          <mat-expansion-panel-header (click)="changeIndex(6)">
            <div class="header-content">
              <mat-panel-title class="page-header">
                <mat-icon class="header-icon">info</mat-icon>
                Miscellaneous
              </mat-panel-title>
            </div>
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-12">
              <mat-label class="field-label">Any other information that you wish to declare?</mat-label>
              <mat-form-field class="w-100">
                <textarea matInput rows="4" formControlName="additionalInfo" placeholder="Enter text here"></textarea>
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-error>
        @if(this.submitmessage != '') {
        <span>{{submitmessage}}</span>
        }
        @else {
        <span></span>
        }
      </mat-error>
    </form>
    @if (showPreview) {
    <div class="preview-backdrop" (click)="closePreview()"></div>

    <div class="preview-panel">
      <div class="preview-header d-flex justify-content-between align-items-center p-3 border-bottom">
        <div class="d-flex flex-column">
          <span class="fw-bold fs-5">Document Preview</span>
          <small class="text-muted">{{ currentFileName }}</small>
        </div>
        <div class="preview-header-actions">
          @if (!isPdf) {
          <button mat-icon-button (click)="zoomOut()" [disabled]="zoomLevel <= MIN_ZOOM" title="Zoom out">
            <mat-icon>zoom_out</mat-icon>
          </button>
          <span class="zoom-level">{{ zoomLevel * 100 }}%</span>
          <button mat-icon-button (click)="zoomIn()" [disabled]="zoomLevel >= MAX_ZOOM" title="Zoom in">
            <mat-icon>zoom_in</mat-icon>
          </button>
          }
          <button mat-icon-button color="warn" (click)="closePreview()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <div class="preview-content">
        @if (isPdf) {
        <iframe [src]="selectedDocument" width="100%" height="100%" frameborder="0"></iframe>
        } @else {
        <img [src]="selectedDocument" alt="Document Preview" class="preview-image"
          [style.transform]="'scale(' + zoomLevel + ')'" />
        }
      </div>
    </div>
    }

    @if(this.mode != 'view'){
    <div class="form-actions mt-4">
      <!-- (click)="returnByRole()" -->
      <button class="save-btn" (click)="returnDeclaration()">
        <mat-icon>arrow_backward</mat-icon>
        <span>Return Declaration</span>
      </button>
      <button color="primary" class="save-btn" (click)="submitForm()">
        <span>Submit</span>
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>
    }
  </div>
</app-pias-layout>